import { Controller } from "@hotwired/stimulus"

export default class SpecialNeedFormController extends Controller {
  static targets = ["otherNeed", "otherNeedField", "selectCode"]

  static classes = ["hidden"]

  checkOtherSelected() {
    if (this.selectCodeTarget.value == "Other") {
      this.otherNeedTarget.classList.remove(this.hiddenClass)
      this.otherNeedFieldTarget.focus()
    }
    else {
      this.otherNeedTarget.classList.add(this.hiddenClass)
    }
  }
}
